/**
 * Created by Ning Jiang on 2021-06-16.
 */

import {WinPresentationController} from "../WinPresentationController";
import {TombstoneRip} from "../../TombstoneRip";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TombstoneRipGameConfig} from "../../TombstoneRipGameConfig";
import {TombstoneRipGameMode} from "../../gameflow/TombstoneRipGameMode";
import {TombstoneRipSymbolState} from "../../symbol/TombstoneRipSymbolConfig";

export class NoWinSymbolsController extends WinPresentationController {

    constructor() {
        super("NoWinSymbolsController", false);
    }

    protected hasWin():boolean {
        return (TombstoneRip.model.parsedGameData.betWins.length > 0);
    }

    protected async createWinAnimation():Promise<void> {
        const symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(TombstoneRipGameConfig.REELS_NUM, () => {
            return ArrayHelper.initArrayWithValues<boolean>(3, () => false)
        });
        const gameData = TombstoneRip.model.parsedGameData;

        gameData.betWins.forEach(winWay => {
            winWay.reelWinPositions.forEach((reelWin, reelId) => {
                reelWin.forEach((symWin, symId) => {
                    if(symWin) {
                        symbolWinStates[reelId][symId] = true;
                    }
                });
            });
        });

        if(gameData.freespinTriggeredThisSpin) {
            gameData.scatterPositions?.forEach((symId, reelId) => {
                if(symId > -1) {
                    symbolWinStates[reelId][symId] = true;
                }
            });
        }

        // winning super fs or upgrading, mark S2
        if(gameData.nextMode === TombstoneRipGameMode.FREESPIN_SUPER && gameData.mode != TombstoneRipGameMode.FREESPIN_SUPER) {
            symbolWinStates[4][0] = true;
        }

        symbolWinStates.forEach((reelWin, reelId) => {
            reelWin.forEach((w, symId) => {
                if(w) {
                    return;
                }

                const symbol = TombstoneRip.reels[reelId].getSymbol(symId);
                // Normal no win
                if(TombstoneRip.model.parsedGameData.singleWin > 0) {
                    symbol.getStateAnimation(
                        TombstoneRipSymbolState.NO_WIN,
                        {duration : 0.1, alpha : 1},
                        {duration : 0.1, alpha : 0}
                    );
                } else { // xRip noWin, reset all the reel hint darken symbols to normal.
                    symbol.getStateAnimation(
                        TombstoneRipSymbolState.NORMAL,
                        {duration : 0.2, alpha : 1},
                        {duration : 0.5, alpha : 0}
                    );
                }
            });
        });

        await Promise.resolve();
    }
}